import http from "../http-common";

const getOrganizations = (token) => {
  return http.get(`/api/v1/organization/list`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getOrganizationInfo = (token, id) => {
  return http.get(`/api/v1/organization/id?id=${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const sendValidationEmail = (token, data) => {
  return http.post(`/api/v1/tenantPermissions/sendValidationEmail`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getMsUsersByGraph = ({ token, organizationId }) => {
  return http.get(
    `/api/v1/organization/getMsUsersByGraph?organizationId=${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
const getMsDomainsByGraph = ({ token, organizationId }) => {
  return http.get(
    `/api/v1/organization/getMsDomainsByGraph?organizationId=${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const createMsDomainByGraph = ({ token, data }) => {
  return http.post(`/api/v1/organization/createMsDomainByGraph`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getDomainVerificationDnsRecords = ({
  token,
  organizationId,
  domainName,
}) => {
  return http.get(
    `/api/v1/organization/getDomainVerificationDnsRecords?organizationId=${organizationId}&domainName=${domainName}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const verifyMsDomainByGraph = ({ token, data }) => {
  return http.post(`/api/v1/organization/verifyMsDomainByGraph`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getTrunksByPowershell = ({ token, organizationId }) => {
  return http.get(
    `/api/v1/organization/getTrunksByPowershell?organizationId=${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const getTeamsUsersByPowershell = ({ token, organizationId }) => {
  return http.get(
    `/api/v1/organization/getTeamsUsersByPowershell?organizationId=${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const applyUserConfig = ({ token, data }) => {
  return http.post(`/api/v1/organization/applyUserConfig`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const unapplyUserConfig = ({ token, data }) => {
  return http.post(`/api/v1/organization/unapplyUserConfig`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const updateDatabaseUser = ({ token, data }) => {
  return http.put(`/api/v1/organization/updateDatabaseUser`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const createDatabaseUser = ({ token, data }) => {
  return http.post(`/api/v1/organization/createDatabaseUser`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteDatabaseUser = ({ token, data }) => {
  return http.delete(`/api/v1/organization/deleteDatabaseUser`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  });
};

const getLicensesByMsGraph = ({ token, organizationId, email }) => {
  return http.get(
    `/api/v1/organization/getLicensesByMsGraph?organizationId=${organizationId}&email=${email}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const assignLicenses = ({ token, data }) => {
  return http.post(`/api/v1/organization/assignLicenses`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const createOrganization = ({ token, data }) => {
  return http.post(`/api/v1/organization/create`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const createTrunkByPowerShell = ({ token, data }) => {
  return http.post(`/api/v1/organization/createTrunkByPowerShell`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const OrganizationService = {
  getOrganizations,
  getOrganizationInfo,
  sendValidationEmail,
  getMsUsersByGraph,
  getMsDomainsByGraph,
  createMsDomainByGraph,
  getDomainVerificationDnsRecords,
  verifyMsDomainByGraph,
  getTrunksByPowershell,
  getTeamsUsersByPowershell,
  applyUserConfig,
  unapplyUserConfig,
  updateDatabaseUser,
  createDatabaseUser,
  deleteDatabaseUser,
  getLicensesByMsGraph,
  assignLicenses,
  createOrganization,
  createTrunkByPowerShell,
};

export default OrganizationService;
